import Box from '@mui/material/Box'
import ListSubheader from '@mui/material/ListSubheader'
import type {} from '@mui/material/themeCssVarsAugmentation'
import * as React from 'react'
import { DRAWER_WIDTH } from '../constants'
import PageSidebarContext from '../context/PageSidebarContext'
import { getDrawerSxTransitionMixin } from '../mixins'

export interface PageSidebarHeaderItemProps {
  children?: React.ReactNode
  icon?: React.ReactNode
}

export default function PageSidebarHeaderItem({ children, icon }: PageSidebarHeaderItemProps) {
  const sidebarContext = React.useContext(PageSidebarContext)
  if (!sidebarContext) {
    throw new Error('Sidebar context was used without a provider.')
  }
  const { mini = false, fullyExpanded = true, hasDrawerTransitions } = sidebarContext

  return (
    <ListSubheader
      sx={{
        fontSize: 12,
        fontWeight: '600',
        height: mini ? 0 : 36,
        ...(hasDrawerTransitions ? getDrawerSxTransitionMixin(fullyExpanded, 'height') : {}),
        px: 1.5,
        py: 0,
        minWidth: DRAWER_WIDTH,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {icon && !mini ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 16,
            opacity: 0.7,
          }}
        >
          {icon}
        </Box>
      ) : null}
      {children}
    </ListSubheader>
  )
}
